import { DISCOUNTTYPE, LineDiscount, TProduct, TransactionDiscount, TransactionDocument, TRANSACTION_TYPE } from "./mapper-library.model"
import { TransactionDocumentBuilder } from "./TransactionDocumentBuilder";
import {AppLoggerService} from '@pmcretail/common-services/common/app-logger.service';
export class RJMapperBuilderClass {

    className = "RJMapperBuilderClass";
    private transactionDocument: TransactionDocument;
    private deviceId: any;
    private transactionNumber: any;
    private manifestVersion: any;
    private databaseSchemaVersion: any;
    private basketType: any;
    private xmlSchemaVersion: any;
    private majorVersion: any;
    private minorVersion: any;
    private externalState: any;
    private cashierId: any;
    private companyId: any;
    private terminalNumber: any;
    private taxMethodId: any;
    private tradingRegionId: any;
    private basketCurrencyId: any;
    private basketCountryId: any;
    private basketLanguageId: any;
    private itemCount = 0;
    private largestNumber = 0;
    private branchId: any;
    private createdAt: any;
    private updatedAt :any;
    private salesPersonName: any;
    private rjObject: any = {}

    constructor(transactionDoc?: TransactionDocument) {
        if (transactionDoc) {
            this.transactionDocument = transactionDoc;
        } else {
            this.transactionDocument = {
                transactionId: "",
                offlineTransactionId: "",
                transactionRef: "",
                dateTime: "",
                orgCode: "",
                storeId: "",
                storeNodeId: "",
                storeNodeStructure: "",
                deviceId: "",
                terminalId: "",
                userId: "",
                initiatingModule: "eBasket",
                export: false,
                basket: {} as any,
                basketSummary: {} as any,
                baseCurrency: "",
                type: "",
                operationStatus: "",
                createdAt: "",
                updatedAt: "",
                id: "",
                currentTransactionDetails: {} as any,
                saleTotal: 0,
            };
        }
        this.initilizeItemCount();
        this.setLineNumberForProducts();
        this.createdAt = this.getDate(this.transactionDocument.createdAt);
        this.updatedAt = this.getDate(this.transactionDocument.updatedAt);
    }

    getPosbasketInfo() {
        this.rjObject['Keyword'] = this.generateKeyword();
        this.rjObject['ID'] = this.generateId(this.createdAt);
        this.rjObject['XMLSchemaVersion'] = '2';
        this.rjObject['LastUpdated'] = this.updatedAt;
        this.rjObject['MajorVersion'] = this.majorVersion;
        this.rjObject['MinorVersion'] = this.minorVersion;
        this.rjObject['ManifestVersion'] = this.manifestVersion;
        this.rjObject['DatabaseSchemaVersion'] = this.databaseSchemaVersion;
        this.rjObject['BasketType'] = this.basketType;
        this.rjObject['State'] = this.getState();
        this.rjObject['ExternalState'] = this.externalState;

        return this;
    }


    getheaderInfo() {
        this.rjObject['Header'] = {};
        this.rjObject['Header'].TimeZoneOffset = this.convertToString(this.generateTimezoneoffset(this.transactionDocument.createdAt));
        this.rjObject['Header'].DateTimeCreated = this.createdAt;
        this.rjObject['Header'].OriginatedBy = {};
        this.rjObject['Header'].OriginatedBy.DeviceID = this.deviceId;
        this.rjObject['Header'].OriginatedBy.CashierID = this.cashierId;
        this.rjObject['Header'].OriginatedBy.CompanyID = this.companyId;
        this.rjObject['Header'].OriginatedBy.StoreID = this.transactionDocument.storeId;
        this.rjObject['Header'].OriginatedBy.BranchID = this.branchId;
        this.rjObject['Header'].OriginatedBy.TerminalNumber = this.terminalNumber;
        this.rjObject['Header'].OriginatedBy.TransactionNumber = this.transactionNumber;
        this.rjObject['Header'].TaxMethodID = this.taxMethodId;
        this.rjObject['Header'].DynamicStockLookup = this.generateDynamicStockLookUp();
        this.rjObject['Header'].BasketLanguageID = this.basketLanguageId; //todo
        this.rjObject['Header'].BasketCountryID = this.basketCountryId; //todo
        this.rjObject['Header'].BasketCurrencyID = this.transactionDocument.baseCurrency;
        this.rjObject['Header'].TradingRegionID = this.tradingRegionId;
        this.rjObject['Header'].Eurozone = " ";//unknown
        this.rjObject['Header'].EuroBaseExchangeRate = ""; //unknown
        this.rjObject['Header'].PrintableName = this.transactionDocument.userName; //unknown

        return this;
    }

    rjMapper() {
        var transactionDiscount:any = [] ;
        if (this.transactionDocument.basket.transactionDiscount && this.transactionDocument.basket.transactionDiscount.length > 0) {
             transactionDiscount = this.transactionDocument.basket.transactionDiscount
        }
        if (this.transactionDocument.type === TRANSACTION_TYPE.SALE) {
            this.rjObject['ProductSale'] = [];
            this.rjObject['ModifierItem'] = [];

            this.transactionDocument.basket.products.forEach((element: any) => {
                let lineDiscount = [];
                if (this.transactionDocument.basket.lineDiscount && this.transactionDocument.basket.lineDiscount.length > 0) {
                    lineDiscount = this.transactionDocument.basket.lineDiscount.filter((x: any) => x.itemLineId === element.itemLineId);
                    if (lineDiscount.length > 0) {
                        const index = this.transactionDocument.basket.lineDiscount.indexOf(lineDiscount[0]);
                        if (index > -1) {
                            this.transactionDocument.basket.lineDiscount.splice(index, 1);
                        }
                    }
                }
                let data = this.addProduct(element, (lineDiscount.length > 0 ? lineDiscount[0] : null),(transactionDiscount.length > 0 ? transactionDiscount : null));
                this.rjObject['ProductSale'].push(data);
                this.getModifierItem(lineDiscount.length > 0 ? lineDiscount[0] : null, element.itemLineId);
            });
            let transactionPromotion = [];
            if (this.transactionDocument.basket.transactionPromotion && this.transactionDocument.basket.transactionPromotion.length > 0) {
                transactionPromotion = this.transactionDocument.basket.transactionPromotion;
                this.getTransactionPromotion(transactionPromotion);
            }
        } else if (this.transactionDocument.type === TRANSACTION_TYPE.REFUND) {
            this.rjObject['ProductReturn'] = [];
            this.rjObject['ModifierItem'] = [];            
            this.transactionDocument.basket.products.forEach((element: any) => {
                let data = this.returnProduct(element, (element.hasOwnProperty('lineDiscount') ? element.lineDiscount : null),(transactionDiscount.length > 0 ? transactionDiscount : null));
                this.rjObject['ProductReturn'].push(data);
                this.getModifierItem(element.lineDiscount, element.itemLineId);
            });
        } else if (this.transactionDocument.type === TRANSACTION_TYPE.SALE_REFUND) {
            this.rjObject['ProductReturn'] = [];
            this.rjObject['ModifierItem'] = [];
            
            let transactionDoc: any = new TransactionDocumentBuilder().basket(this.transactionDocument.currentTransactionDetails).build();
            transactionDoc.basket.products.forEach((element: any) => {
                let data = this.returnProduct(element, (element.hasOwnProperty('lineDiscount') ? element.lineDiscount : null),(transactionDiscount.length > 0 ? transactionDiscount : null));
                let obj = {
                    "OriginalReceiptSupplied": 0,
                    "OriginalBranchID": 0,
                    "OriginalTerminalNumber": 0,
                    "OriginalTransactionNumber": 0,
                    "OriginalCashierNumber": 0
                };
                data['Return'] = {...data['Return'], ...obj};
                this.rjObject['ProductReturn'].push(data);
                this.getModifierItem(element.lineDiscount, element.itemLineId);
            })
        } else if (this.transactionDocument.type === TRANSACTION_TYPE.SALE_EXCHANGE) {
            this.rjObject['ProductReturn'] = [];
            this.rjObject['ProductSale'] = [];
            this.rjObject['ModifierItem'] = [];
            
            let transactionDoc: any = new TransactionDocumentBuilder().basket(this.transactionDocument.currentTransactionDetails).build();
            transactionDoc.basket.products.forEach((element: any) => {
                if (element.refundedQuantity > 0) {
                    let returnProduct = this.returnProduct(element, (element.hasOwnProperty('lineDiscount') ? element.lineDiscount : null),(transactionDiscount.length > 0 ? transactionDiscount : null));
                    let obj = {
                        "OriginalReceiptSupplied": 0,
                        "OriginalBranchID": 0,
                        "OriginalTerminalNumber": 0,
                        "OriginalTransactionNumber": 0,
                        "OriginalCashierNumber": 0
                    };
                    returnProduct['Return'] = {...returnProduct['Return'], ...obj};
                    this.rjObject['ProductReturn'].push(returnProduct);
                } else {
                    let addProduct = this.addProduct(element, (element.hasOwnProperty('lineDiscount') ? element.lineDiscount : null) ,(transactionDiscount.length > 0 ? transactionDiscount : null));
                    this.rjObject['ProductSale'].push(addProduct);
                }
                this.getModifierItem(element.lineDiscount, element.itemLineId);
            })

        }
        return this;
    }

    getBasketDiscount() {
        if (!this.transactionDocument.basket.transactionDiscount) return this;
        this.rjObject['BasketDiscount'] = [];
        this.transactionDocument.basket.transactionDiscount.forEach((element: any) => {
            let obj: any = {}
            obj['XMLSchemaVersion'] = this.xmlSchemaVersion;
            obj['DeviceID']=this.deviceId;
            obj['DateTimeCreated']=this.updatedAt;
            obj['NetValue'] = this.convertToString(element.discountAmount * -1);
            obj['EffectiveNetValue'] =this.convertToString( element.discountAmount * -1);
            obj['Description'] = element.reasonDisplayText;
            obj['UserID'] = this.transactionDocument.userName;
            obj['ReasonCodeID'] = element.reasonCode;
            obj['DiscountType'] = this.convertToString(element.discountType.toUpperCase() == DISCOUNTTYPE.PERCENT.toUpperCase() ? 0 : 1); 
            obj['RoundingRule'] = this.convertToString(2);
            obj['ModifiedLineNumber'] = element.itemLineIds;           
            obj['LineNumber'] = this.convertToString(this.generateLineNumber()); 
            obj['DiscountedValue'] =  this.transactionDocument.basketSummary.basketTotal + this.transactionDocument.basketSummary.discountTotal;
            if(element.discountType.toUpperCase() == DISCOUNTTYPE.PERCENT.toUpperCase()){
                obj['DiscountPercentage'] =  this.convertToString((element.discountAmount / this.transactionDocument.basketSummary.basketTotal).toFixed(1))
            }
            if(this.transactionDocument.type === 'REFUND'){
                obj['NetValue'] = this.convertToString(element.discountAmount < 0 ? -element.discountAmount : element.discountAmount);
                obj['EffectiveNetValue'] =this.convertToString( element.discountAmount < 0 ? -element.discountAmount : element.discountAmount);
            }

            this.rjObject['BasketDiscount'].push(obj);
        });
        return this;
    }

    getModifierItem(data: any, lineNo: any) {
        if (data && lineNo) {
            let obj: any = {};
            obj.XMLSchemaVersion = 1;
            obj.LineNumber = this.generateLineNumber();
            obj.NetValue = 0;
            obj.EffectiveNetValue = 0;
            obj.Description = data.percentageDiscountReasonName ? data.percentageDiscountReasonName : data.priceOverrideReasonName;
            obj.DeviceID = this.deviceId;
            obj.UserID = this.transactionDocument.userName;
            obj.DateTimeCreated = this.updatedAt;
            obj.AuthorisingUserID = this.transactionDocument.userName;
            obj.ReasonCodeID = data.percentageDiscountReasonCode ? data.percentageDiscountReasonCode : data.priceOverrideReasonCode;
            obj.ModifiedLineNumber = lineNo;
            obj.ModifiedIndex = 1;

            this.rjObject['ModifierItem'].push(obj);
        }
    }

    getTrailerInfo() {
        this.rjObject['Trailer'] = {};
        this.rjObject.Trailer.DateTimeCompleted = this.updatedAt;
        this.rjObject.Trailer.CompletedBy = {};
        this.rjObject.Trailer.CompletedBy.DeviceID = this.deviceId;
        this.rjObject.Trailer.CompletedBy.CashierID = this.cashierId;
        this.rjObject.Trailer.CompletedBy.StoreID = this.transactionDocument.storeId;
        this.rjObject.Trailer.CompletedBy.BranchID = this.branchId;
        this.rjObject.Trailer.CompletedBy.TerminalNumber = this.terminalNumber;
        this.rjObject.Trailer.CompletedBy.TransactionNumber = this.transactionNumber;
        this.rjObject.Trailer.Total = this.convertToString(this.transactionDocument.basketSummary.basketTotal * 100);
        this.rjObject.Trailer.ItemCount = this.itemCount; //gives total count for product
        this.rjObject.Trailer.ItemQuantity = this.convertToString(this.transactionDocument.basketSummary.totalItems);
        this.rjObject.Trailer.NetItemQuantity = this.convertToString(this.transactionDocument.basketSummary.totalItems);
        this.rjObject.Trailer.TaxTotal = this.convertToString(this.removeDecimal(this.transactionDocument.basketSummary.VATTotal));
        this.rjObject.Trailer.SequenceDeviceID = this.deviceId;
        this.rjObject.Trailer.SequenceNumber = 'snsn' //static for now

        this.rjObject['Trailer']['TaxItem'] = [];
        this.transactionDocument.basket.taxBreakdown.taxLines.forEach((element: any) => {
            let obj: any = {};

            obj['XMLSchemaVersion'] = this.xmlSchemaVersion;
            obj['TaxRate'] = this.convertToString(element.VATCode);
            obj['TaxableTotal'] = this.convertToString(this.removeDecimal(element.taxableAmount));
            obj['TaxTotal'] = this.convertToString(this.removeDecimal(this.removeDecimal(element.taxLineTotal)));
            obj['TaxDescription'] = this.convertToString(element.VATCode);
            obj['TaxIncluded'] = '1';
            obj['TaxPercentage'] = this.addDecimal(element.VAT.toFixed(2)).toFixed(2);

            this.rjObject['Trailer']['TaxItem'].push(obj)
        });
        if (this.transactionDocument.basket.linePromotion.length > 0 || this.transactionDocument.basket.linePromotion.length > 0) {
            this.rjObject['Trailer']['PromotionItem'] = [];
            if (this.transactionDocument.basket.linePromotion.length > 0) {
                this.transactionDocument.basket.linePromotion.forEach((element: any) => {
                    let obj: any = {};

                    obj['PromotionID'] = element.promotionId;
                    obj['PromotionSaving'] = element.promotionAmount < 0 ? element.promotionAmount : -element.promotionAmount;
                    obj['PromotionQuantity'] = "1";
                    obj['PromotionDescription'] = element.displayText;
                    obj['PromotionHit'] = {}
                    obj['PromotionHit']['XMLSchemaVersion'] = this.xmlSchemaVersion;
                    obj['PromotionHit']['HitNumber'] = "1";
                    obj['PromotionHit']['HitQuantity'] = "1";
                    obj['PromotionHit']['HitSaving'] = element.promotionAmount < 0 ? element.promotionAmount : -element.promotionAmount;
                    obj['PromotionHit']['PromotionTrigger'] = {};
                    let product = this.transactionDocument.basket.products.find((item: any) => item.itemLineId == element.itemLineId);
                    obj['PromotionHit']['PromotionTrigger']['XMLSchemaVersion'] = this.xmlSchemaVersion;
                    obj['PromotionHit']['PromotionTrigger']['ProductID'] = product.SKU;
                    obj['PromotionHit']['PromotionTrigger']['UnitValue'] = this.convertToString(element.promotionLinePrice / product.quantity);
                    obj['PromotionHit']['PromotionTrigger']['LineNumber'] = this.getNumber(product.SKU);
                    obj['PromotionHit']['PromotionTrigger']['Quantity'] = this.convertToString(product.quantity.toFixed(1));
                    obj['PromotionHit']['PromotionTrigger']['TaxCode'] = this.transactionDocument.basket.taxBreakdown.taxLines.find((item: any) => item.itemLineId == element.itemLineId).VATCode;
                    this.rjObject['Trailer']['PromotionItem'].push(obj);
                });
            }

            if (this.transactionDocument.basket.transactionPromotion.length > 0) {

                this.transactionDocument.basket.transactionPromotion.forEach((element: any) => {
                    let obj: any = {};
                    obj['PromotionID'] = element.promotionId;
                    obj['PromotionSaving'] = element.promotionAmount < 0 ? element.promotionAmount : -element.promotionAmount;
                    obj['PromotionQuantity'] = "1";
                    obj['PromotionDescription'] = element.displayText;
                    obj['PromotionHit'] = {}
                    obj['PromotionHit']['XMLSchemaVersion'] = this.xmlSchemaVersion;
                    obj['PromotionHit']['HitNumber'] = "1";
                    obj['PromotionHit']['HitQuantity'] = "1";
                    obj['PromotionHit']['HitSaving'] = element.promotionAmount < 0 ? element.promotionAmount : -element.promotionAmount;
                    obj['PromotionHit']['PromotionTrigger'] = [];
                    this.transactionDocument.basket.products.forEach((product: any) => {
                        let promotionTrigger = {};
                        element.itemLineIds.forEach((itemLineId: any) => {
                            if (JSON.stringify(itemLineId) === product.itemLineId) {
                                promotionTrigger['XMLSchemaVersion'] = this.xmlSchemaVersion;
                                promotionTrigger['ProductID'] = product.SKU;
                                promotionTrigger['UnitValue'] = this.convertToString(element.promotionLinePrice / product.quantity);
                                promotionTrigger['LineNumber'] = this.getNumber(product.SKU);
                                promotionTrigger['Quantity'] = this.convertToString(product.quantity);
                                promotionTrigger['TaxCode'] = this.transactionDocument.basket.taxBreakdown.taxLines.find((item: any) => item.itemLineId == product.itemLineId).VATCode;
                                obj['PromotionHit']['PromotionTrigger'].push(promotionTrigger);
                            }
                        });
                    });
                    this.rjObject['Trailer']['PromotionItem'].push(obj);
                });
            }
        }
        return this;
    }

    getTenderInfo() {
        if (this.transactionDocument.paymentDetails && this.transactionDocument.paymentDetails.length > 0) {
            this.transactionDocument.paymentDetails.forEach((element: any) => {
            if(element.externalTenderKey){
                this.rjObject[element.externalTenderKey] = [];
                if (element.paymentType.toUpperCase() === 'GIFT CARD') {
                    let obj = {
                        XMLSchemaVersion: this.xmlSchemaVersion,
                        LineNumber: this.generateLineNumber(),
                        NetValue: this.convertToString(-1 * this.removeDecimal((Math.round(element.amount)))),
                        EffectiveNetValue: this.convertToString(-1 * this.removeDecimal((Math.round(element.amount)))),
                        Description: this.getDescription(element),
                        DeviceID: this.deviceId,
                        UserID: this.transactionDocument.userName,
                        DateTimeCreated: this.updatedAt,
                        TenderType: element.externalTenderType ? element.externalTenderType : '',
                        TenderSubType: element.externalSubTenderType ? element.externalSubTenderType : '',
                        TenderAmount: this.convertToString(-1 * this.removeDecimal((Math.round(element.amount)))),
                        CurrencyID: this.transactionDocument.baseCurrency,
                        CurrencyDescription: this.transactionDocument.baseCurrency,
                        GiftVoucherSalesAllowed: '',//todo
                        AllowRechargeableVoucherSales: '',//todo
                        GiftVoucherID: ''
                    }
                    this.rjObject[element.externalTenderKey].push(obj)
                }
                else {
                    let obj1 = {
                        XMLSchemaVersion: "1",
                        LineNumber: this.generateLineNumber(),//todo
                        NetValue: this.convertToString(-1 * this.removeDecimal(Math.round(element.amount))),
                        EffectiveNetValue: this.convertToString(-1 * this.removeDecimal(Math.round(element.amount))),
                        Description: this.getDescription(element),
                        DeviceID: this.deviceId,
                        UserID: this.transactionDocument.userName,
                        DateTimeCreated: this.updatedAt,
                        TenderType: element.externalTenderType ? element.externalTenderType : '',
                        TenderSubType: element.externalSubTenderType ? element.externalSubTenderType : '',
                        TenderAmount: this.convertToString(-1 * this.removeDecimal(Math.round(element.amount))),
                        CurrencyID: this.transactionDocument.baseCurrency,
                        CurrencyDescription: this.transactionDocument.baseCurrency,
                        IncludeInTransactionTotalCheck: "1",
                        AllowRechargeableVoucherSales: "1",
                        OpenDrawerAtEnd: "1"
                    }
                    this.rjObject[element.externalTenderKey].push(obj1)
                }
            } else{
                this.rjObject['CashTender'] = [];
                if (element.paymentType.toUpperCase() === 'GIFT CARD') {
                    let obj = {
                        XMLSchemaVersion: this.xmlSchemaVersion,
                        LineNumber: this.generateLineNumber(),
                        NetValue: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        EffectiveNetValue: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        Description: this.getDescription(element),
                        DeviceID: this.deviceId,
                        UserID: this.transactionDocument.userName,
                        DateTimeCreated: this.updatedAt,
                        TenderType: element.externalTenderType ? element.externalTenderType : '',
                        TenderSubType: element.externalSubTenderType ? element.externalSubTenderType : '',
                        TenderAmount: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        CurrencyID: this.transactionDocument.baseCurrency,
                        CurrencyDescription: this.transactionDocument.baseCurrency,
                        GiftVoucherSalesAllowed: '',//todo
                        AllowRechargeableVoucherSales: '',//todo
                        GiftVoucherID: ''
                    }
                    this.rjObject['CashTender'].push(obj)
                }
                else {
                    let obj1 = {
                        XMLSchemaVersion: "1",
                        LineNumber: this.generateLineNumber(),
                        NetValue: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        EffectiveNetValue: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        Description: this.getDescription(element),
                        DeviceID: this.deviceId,
                        UserID: this.transactionDocument.userName,
                        DateTimeCreated: this.updatedAt,
                        TenderType: element.externalTenderType ? element.externalTenderType : '',
                        TenderSubType: element.externalSubTenderType ? element.externalSubTenderType : '',
                        TenderAmount: JSON.stringify(-1 * this.removeDecimal((Math.round(element.amount)))),
                        CurrencyID: this.transactionDocument.baseCurrency,
                        CurrencyDescription: this.transactionDocument.baseCurrency,
                        IncludeInTransactionTotalCheck: "1",
                        AllowRechargeableVoucherSales: "1",
                        OpenDrawerAtEnd: "1"
                    }
                    this.rjObject['CashTender'].push(obj1)
                }
            }
            });
        }
        return this;
    }

    getNumber(productId) {
        let lineNumber; 
        for (let i = 0; i < this.rjObject['ProductSale'].length; i++) {
            const element = this.rjObject['ProductSale'][i];
            if(JSON.stringify(productId) === JSON.stringify(element.ProductID)){
                lineNumber = element.LineNumber;
                break;
            }
        }
        return lineNumber;
    }

    setLineNumberForProducts() {
        let itemLineIdArray = [];
        itemLineIdArray = this.transactionDocument.basket.products.map((product: any) => {
            return parseInt(product.itemLineId);
        })
        this.largestNumber = itemLineIdArray.reduce((a: any, b: any) => Math.max(a, b));
    }

    generateLineNumber() {
        this.largestNumber += 1;
        this.itemCount += 1;
        return this.largestNumber;
    }

    initilizeItemCount() {
        this.itemCount = this.transactionDocument.basket.products.length;
    }

    build() {
        return this.rjObject;
    }

    getDescription(element: any) {
        if (element.paymentType.toUpperCase() === 'CARD') {
            return element.cardType
        }
        else {
            return element.paymentType;
        }
    }

    getMMGROUPID(attributes) {
        if (attributes && attributes.length > 0) {
            let filterValue = attributes.filter((attribute) => attribute.name === "MMGROUPID");
            if(filterValue && filterValue.length > 0){
            return filterValue[0].value;
            }
        }
    }

    setDeviceInfo(id: any) {
        this.deviceId = id
        return this
    }

    removeDecimal(value: number) {
        return value * 100;
    }

    addDecimal(value: number) {
        return value /100;
    }

    setTransactionNumber(value: any) {
        this.transactionNumber = value;
        return this
    }

    setManifestVersion(value: any) {
        this.manifestVersion = value;
        return this
    }

    setDatabaseSchemaVersion(value: any) {
        this.databaseSchemaVersion = value;
        return this
    }

    setBasketType(value: any) {
        this.basketType = value;
        return this
    }

    setTradingRegionID(value: any) {
        this.tradingRegionId = value
        return this
    }

    setCompanyID(value: any) {
        this.companyId = value
        return this
    }

    setTaxMethodID(value: any) {
        this.taxMethodId = value
        return this
    }

    setMajorVersion(value: any) {
        this.majorVersion = value
        return this
    }

    setMinorVersion(value: any) {
        this.minorVersion = value
        return this
    }

    setXMLSchemaVersion(value: any) {
        this.xmlSchemaVersion = value
        return this
    }

    setExternalState(value: any) {
        this.externalState = value
        return this
    }

    setCashierID() {
        this.cashierId = (this.transactionDocument && this.transactionDocument.userName) ?  this.transactionDocument.userName : '';
        return this
    }

    setTerminalNumber(value: any) {
        this.terminalNumber = value;
        return this;
    }

    setBasketLanguageID(value: any) {
        this.basketLanguageId = value;
        return this;
    }
    setBasketCountryID(value: any) {
        this.basketCountryId = value;
        return this;
    }

    setBasketCurrencyID(value: any) {
        this.basketCurrencyId = value;
        return this;
    }

    setBranchID(value: any) {
        this.branchId = value;
        return this;
    }

    setSalesPersonName(value: any) {
        this.salesPersonName = value;
        return this;
    }

    generateId(date: any) {
        let newDateTime = date.replace(/[^0-9]/g, '')
        let id = (this.deviceId + '|' + newDateTime + '|' + this.transactionNumber).toString();
        return id;
    } 

    generateTimezoneoffset(date: any) {
        let x = date ? date : '';
        return new Date(x).getTimezoneOffset();
    }

    generateKeyword() {
        let x = (this.companyId + '|' + this.transactionDocument.storeId + '|' + this.terminalNumber + '|' + this.transactionNumber).toString();
        return x;
    }

    getState() {
        if (this.transactionDocument.operationStatus === 'PAY_SUCCESS') {
            return 'Completed';
        }
        else {
            return 'Cancelled';
        }
    }

    returnProduct(element: any, lineDiscount: LineDiscount , transactionDiscount: TransactionDiscount) {
        let obj: any = {};
        let taxTotal = this.transactionDocument.basket['taxBreakdown']['taxLines'].find((item: any) => item.itemLineId == element['itemLineId']);
        obj['XMLSchemaVersion'] = this.xmlSchemaVersion;
        obj['LineNumber'] = element['itemLineId'];
        obj['NetValue'] = this.removeDecimal(element['refundedTotal']);
        obj['EffectiveNetValue'] = this.removeDecimal(element['refundedTotal']);
        obj['Description'] = element['description'];
        obj['DeviceID'] = this.transactionDocument['terminalId'];
        obj['UserID'] = this.transactionDocument.userName;
        obj['DateTimeCreated'] = this.createdAt;
        obj['ExtendedValue'] = this.removeDecimal(element['totalLinePrice']*-1);
        obj['UnitPrice'] = this.removeDecimal(element['price']);
        obj['Quantity'] = this.getQuantity(element);
        obj['OriginalTaxAmountSet'] = 1;
        obj['ProductID'] = element['SKU'];
        obj['HandKeyed'] = 1;
        obj['LongDescription'] = element['description'];
        obj['Return'] = {};
        obj['Return']['ReturnReasonID'] = element['refundedReason'];
        obj['Return']['ReturnDescription'] = element['refundedReasonDescription'];
        obj['Return']['ReturnToStock'] = this.getQuantity(element);
        obj['TaxCode'] = this.transactionDocument.basket['taxBreakdown']['taxLines'].find((item: any) => item.itemLineId == element['itemLineId']).VATCode;

        obj['DisplayTaxCode'] = ''; // todo
        obj['ProductAttributes'] = ''; //todo - not required
        obj['Perishable'] = this.getMMGROUPID(element.attributes);
        //obj['MMGroupID'] = this.getCaregories(element);
        obj['MMGroupID'] = this.getMMGROUPID(element.attributes);
        obj['CustomerDetails'] = ""; // todo - blank
        obj['TotalPromotionSaving'] = element['promotionAmount'] || -1; // TODO
        obj['OriginalTaxAmount'] = this.convertToString((this.removeDecimal(this.getOriginalTax(element,taxTotal.VAT) * -1)).toFixed(2));
        obj['taxAmount'] = this.removeDecimal(taxTotal.taxLineTotal < 0 ?(taxTotal.taxLineTotal) : (-taxTotal.taxLineTotal));

        if (lineDiscount) {
            if (lineDiscount.percentageDiscountReasonName && lineDiscount.percentageDiscountReasonCode) {
                // line discount
                obj['Discount'] = {};
                obj['Discount'].ModifierValue = this.removeDecimal(lineDiscount.discountAmount) * -1;
                obj['Discount'].ModifierDateTime = obj.DateTimeCreated;
                obj['Discount'].ModifierReasonID = lineDiscount.percentageDiscountReasonCode;
                obj['Discount'].ModifierDescription = lineDiscount.percentageDiscountReasonName;
                obj['Discount'].AuthorisingUserID = this.transactionDocument.userName;
                obj['Discount'].DiscountType = lineDiscount.discountType;
                obj['Discount'].XMLSchemaVersion = 1;
                obj['Discount'].OriginalPrice = this.removeDecimal(lineDiscount.discountAmount + (lineDiscount.discountedLinePrice || 0));
                obj['Discount'].DiscountedValue = this.removeDecimal(lineDiscount.unitPrice);
                obj['Discount'].DiscountPercentage = lineDiscount.percentageDiscountValue;
                obj['Discount'].RoundingRule = 2;
            }

            if (lineDiscount.priceOverrideReasonCode && lineDiscount.priceOverrideReasonName) {
                //price override
                obj['PriceOverride'] = {};
                obj['PriceOverride'].ModifierValue = this.removeDecimal(lineDiscount.discountAmount) * -1;
                obj['PriceOverride'].ModifierDateTime = obj.DateTimeCreated;
                obj['PriceOverride'].ModifierReasonID = lineDiscount.priceOverrideReasonCode;
                obj['PriceOverride'].ModifierReasonDescription = lineDiscount.priceOverrideReasonName;
                obj['PriceOverride'].AuthorisingUserID = this.transactionDocument.userName;
                obj['PriceOverride'].XMLSchemaVersion = 1;
                obj['PriceOverride'].NewPrice = this.removeDecimal(lineDiscount.unitPrice);
                obj['PriceOverride'].OriginalPrice = this.removeDecimal(lineDiscount.discountedLinePrice || 0 + lineDiscount.discountAmount);
            }

            //update the product price
            obj.NetValue = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount) * -1;
            obj.EffectiveNetValue = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount) * -1;
            obj.ExtendedValue = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount) * -1;
            obj.UnitPrice = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount) * -1;
        }

        if(transactionDiscount) {
            obj['BasketDiscountModifier'] = [];
            this.transactionDocument.basket.transactionDiscount.forEach((e: any) => {              
                let discountObj: any ={}
                 e.itemLineIds.forEach((x: any) => {
                    if (x == element.itemLineId) {  
                        var discountAmount = this.convertToString(e.discountAmount * -1);                    
                        discountObj.BasketDiscountLineNumber = this.getLineNumber(e,discountAmount);
                        discountObj.XMLSchemaVersion = this.xmlSchemaVersion;
                        discountObj.DiscountedValue = this.getDiscountedValue(element.totalLinePrice, e.discountAmount);
                        obj['BasketDiscountModifier'].push(discountObj);
                    }                    
                });                    
            });
            var totaltransactionDiscount = 0;
            obj['BasketDiscountModifier'].forEach((value:any)=>{
                totaltransactionDiscount = totaltransactionDiscount + value.DiscountedValue;
            });
            //update the product price
            obj['EffectiveNetValue'] = obj.EffectiveNetValue +  totaltransactionDiscount;
        }

        if (this.transactionDocument.basket.transactionPromotion.length > 0) {
            obj['PromotionSaving'] = [];
            this.transactionDocument.basket.transactionPromotion.forEach((transactionPromo: any) => {
                let promotionObj: any = {};
                transactionPromo.itemLineIds.forEach((itemLineId: any) => {
                    if (itemLineId == element.itemLineId) {
                        promotionObj.ModifierValue = transactionPromo.promotionAmount;
                        promotionObj.ModifierDateTime = this.transactionDocument.createdAt;
                        promotionObj.ModifierDescription = transactionPromo.displayText;
                        promotionObj.XMLSchemaVersion = this.xmlSchemaVersion;
                        promotionObj.PromotionID = transactionPromo.promotionId;
                        promotionObj.PromotionDescription = transactionPromo.displayText;
                        promotionObj.HitNumber = '1';
                        promotionObj.PromotionHitProductQuantity = this.getQuantity(element);
                        promotionObj.PromotionHitQuantity = this.getQuantity(element) * -1;
                        obj['PromotionSaving'].push(promotionObj);
                    }
                });
            });
        }

        return obj;
    }

    addProduct(element: TProduct, lineDiscount: LineDiscount, transactionDiscount: TransactionDiscount) {
        let taxTotal = this.transactionDocument.basket['taxBreakdown']['taxLines'].find((item: any) => item.itemLineId == element['itemLineId']);
        let obj: any = {
            XMLSchemaVersion: this.xmlSchemaVersion,
            LineNumber: element.itemLineId,
            NetValue: this.removeDecimal(element.totalLinePrice),
            EffectiveNetValue: this.removeDecimal(element.totalLinePrice),
            Description: element.description,
            DeviceID: this.deviceId,
            UserID: this.transactionDocument.userName,
            DateTimeCreated: this.createdAt,
            ExtendedValue: this.removeDecimal(element.price),
            UnitPrice: this.removeDecimal(element.price),
            //MMGroupID: this.getCaregories(element),
            Quantity: element.quantity,
            SalespersonID: this.transactionDocument.userName,
            SalespersonName: this.salesPersonName,
            TaxCode: this.transactionDocument.basket['taxBreakdown']['taxLines'].find((item: any) => item.itemLineId == element['itemLineId']).VATCode,
            TaxModifiable: "1", //todo
            OriginalTaxAmount : this.convertToString((this.removeDecimal(this.getOriginalTax(element,taxTotal.VAT)).toFixed(2))),
            TaxAmount : this.convertToString(this.removeDecimal(taxTotal.taxLineTotal)),
            OriginalTaxAmountSet: "1",//todo
            ProductID: element.SKU,
            HandKeyed: "1",//todo
            CustomerDetails: "",
            Perishable: this.getMMGROUPID(element.attributes),
            MMGroupID: this.getMMGROUPID(element.attributes)
        }
        if (lineDiscount) {
            if (lineDiscount.percentageDiscountReasonName && lineDiscount.percentageDiscountReasonCode) {
                // line discount
                obj['Discount'] = {};
                obj['Discount'].ModifierValue = this.removeDecimal(lineDiscount.discountAmount) * -1;
                obj['Discount'].ModifierDateTime = obj.DateTimeCreated;
                obj['Discount'].ModifierReasonID = lineDiscount.percentageDiscountReasonCode;
                obj['Discount'].ModifierDescription = lineDiscount.percentageDiscountReasonName;
                obj['Discount'].AuthorisingUserID = this.transactionDocument.userName;
                obj['Discount'].DiscountType = lineDiscount.discountType;
                obj['Discount'].XMLSchemaVersion = 1;
                obj['Discount'].OriginalPrice = this.removeDecimal(lineDiscount.discountAmount + (lineDiscount.discountedLinePrice || 0));
                obj['Discount'].DiscountedValue = this.removeDecimal(lineDiscount.unitPrice);
                obj['Discount'].DiscountPercentage = lineDiscount.percentageDiscountValue;
                obj['Discount'].RoundingRule = 2;
            }

            if (lineDiscount.priceOverrideReasonCode && lineDiscount.priceOverrideReasonName) {
                //price override
                obj['PriceOverride'] = {};
                obj['PriceOverride'].ModifierValue = this.removeDecimal(lineDiscount.discountAmount) * -1;
                obj['PriceOverride'].ModifierDateTime = obj.DateTimeCreated;
                obj['PriceOverride'].ModifierReasonID = lineDiscount.priceOverrideReasonCode;
                obj['PriceOverride'].ModifierReasonDescription = lineDiscount.priceOverrideReasonName;
                obj['PriceOverride'].AuthorisingUserID = this.transactionDocument.userName;
                obj['PriceOverride'].XMLSchemaVersion = this.xmlSchemaVersion;
                obj['PriceOverride'].NewPrice = this.removeDecimal(lineDiscount.unitPrice);
                obj['PriceOverride'].OriginalPrice = this.removeDecimal(lineDiscount.discountedLinePrice || 0 + lineDiscount.discountAmount);
            }

            //update the product price
            obj['NetValue'] = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount);
            obj['EffectiveNetValue'] = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount);
            obj['ExtendedValue'] = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount);
            obj['UnitPrice'] = ((lineDiscount.discountedLinePrice || 0) + lineDiscount.discountAmount);
        }

        if(transactionDiscount) {
            obj['BasketDiscountModifier'] = [];
            this.transactionDocument.basket.transactionDiscount.forEach((e:any) => {                
                let discountObj: any ={};
                 e.itemLineIds.forEach((itemLineId: any) => {
                    if (itemLineId == element.itemLineId) { 
                        let discountAmount = this.convertToString(e.discountAmount * -1);           
                        discountObj.XMLSchemaVersion = this.xmlSchemaVersion;
                        discountObj.DiscountedValue = -(this.getDiscountedValue(element.totalLinePrice, e.discountAmount));
                        discountObj.BasketDiscountLineNumber = this.getLineNumber(e,discountAmount) ;
                        obj['BasketDiscountModifier'].push(discountObj); 
                    }                    
                });                  
            });
            let totaltransactionDiscount = 0;
            obj['BasketDiscountModifier'].forEach((value:any)=>{
                totaltransactionDiscount = totaltransactionDiscount + value.DiscountedValue;
            });
            //update the product price
            obj['EffectiveNetValue'] = obj.EffectiveNetValue +  totaltransactionDiscount;              
        }
        
        if (this.transactionDocument.basket.transactionPromotion.length > 0 || this.transactionDocument.basket.linePromotion.length > 0) {
            obj['DistributedPromotionSaving'] = [];
            if (this.transactionDocument.basket.transactionPromotion.length > 0) {
                this.transactionDocument.basket.transactionPromotion.forEach((e: any) => {
                    let promotionObj: any = {};
                    e.itemLineIds.forEach((itemLineId: any) => {
                        if (itemLineId == element.itemLineId) {
                            promotionObj.PromotionID = e.promotionId;
                            promotionObj.Hit = '1';
                            promotionObj.Saving = this.getSaving(element.totalLinePrice, e.promotionAmount);
                            promotionObj.ISaving = this.getSaving(element.totalLinePrice, e.promotionAmount);
                            obj['DistributedPromotionSaving'].push(promotionObj);
                        }
                    });
                });
            }

            if (this.transactionDocument.basket.linePromotion.length > 0) {
                this.transactionDocument.basket.linePromotion.forEach((linePromotion: any) => {
                    let promotionObj: any = {};
                    if (element.itemLineId == linePromotion.itemLineId) {
                        promotionObj.PromotionID = linePromotion.promotionId;
                        promotionObj.Hit = "1";
                        promotionObj.Saving = linePromotion.promotionLinePrice;
                        promotionObj.ISaving = linePromotion.promotionLinePrice;
                        obj['DistributedPromotionSaving'].push(promotionObj);
                    }
                });
            }
            let transactionPromotion = 0;
            obj['DistributedPromotionSaving'].forEach((value: any) => {
                transactionPromotion = transactionPromotion + value.Saving;
            });
            obj['EffectiveNetValue'] = obj.EffectiveNetValue + transactionPromotion;
        }
        return obj;
    }

    getSaving(price,promotionAmount): any {
        let Saving = (price*promotionAmount)/this.transactionDocument.basketSummary.saleTotal;
        return Saving;
    }

    getLineNumber(value: any,discountAmount:string ){
        let lineNumber;
        for (let i = 0; i < this.rjObject['BasketDiscount'].length; i++) {
            const element = this.rjObject['BasketDiscount'][i];
            if( value.reasonCode === element.ReasonCodeID && discountAmount === element.NetValue){
                lineNumber = element.LineNumber;
                break;                
            }                       
        }
        return lineNumber;        
    }


    getDiscountedValue(price:any ,discountAmount:any ) {
        let DiscountedValue =((price * discountAmount)/this.transactionDocument.basketSummary.saleTotal)*100 ;
        return DiscountedValue;
    }

    getOriginalTax(element: TProduct, VAT) {
        let pricebeforetax = (element.price * 100)/(100 + VAT )
        let originaltax= element.price - pricebeforetax
        return originaltax;
    }

    convertToString(value: any) {
        try {
            value = JSON.stringify(value);
            return value;
        }
        catch (e) {
            AppLoggerService.logError(this.className, "convertToString",  'can not be converted in string', e);
        }
    }

    generateDynamicStockLookUp() {
        let x = '0';
        this.transactionDocument.basket.products.forEach((element: any) => {
            if (element.deliveryMethod === '1' || element.deliveryMethod === '2') {
                x = '1';
            }
        });
        return x;
    }

    // getAttributes(){
    //     let name: string | any[] = []
    //     this.transactionDocument.basket.products.forEach((element: any) => {
    //         if (element && element.attributes && element.attributes.length > 0) {
    //             name = element.attributes.filter((x: any) => x.name.toUpperCase() === element.name.toUpperCase());
    //         }
    //     });
    //     if (name.length > 0) {
    //         return name[0].value
    //     }
    //     else{
    //         return ""
    //     }
    // }

    // getCaregories(element) {
    //     let MMGroupId = " ";
    //     if (element.categories && element.categories.length > 0) {
    //         let categories = element.categories.filter((x) => x.parentId != '');
    //         let value = categories.filter((x) => x.id != x.parentId);
    //         MMGroupId = value[0].name;
    //     }
    //     return MMGroupId;
    // }

    getDate(date:string){
        let offset = this.generateTimezoneoffset(date) * -1;
        let offsetHours = Math.abs(Math.floor(offset / 60));        
	    let offsetMinutes = Math.abs(offset) - offsetHours * 60;

        let offsetSign = '+';
        if (offset < 0) {
            offsetSign = '-';
        }

        let newdate = date.substring(0,19);
        const x = (newdate+ offsetSign +String(offsetHours).padStart(2, '0')+':'+String(offsetMinutes).padStart(2, '0')).toString();
        return x;        
    }
    
    getTransactionPromotion(transactionPromotion){
        if(transactionPromotion && transactionPromotion.length > 0){
            this.rjObject['PromoVoucherItem'] = {};
            this.rjObject['PromoVoucherItem']['XMLSchemaVersion'] = this.xmlSchemaVersion;
            this.rjObject['PromoVoucherItem']['LineNumber'] = this.generateLineNumber();
            this.rjObject['PromoVoucherItem']['NetValue'] =  this.removeDecimal(transactionPromotion[0].promotionLinePrice) * -1;
            this.rjObject['PromoVoucherItem']['EffectiveNetValue'] = this.removeDecimal(transactionPromotion[0].promotionLinePrice) * -1;
            this.rjObject['PromoVoucherItem']['Description'] = transactionPromotion[0].promotionInfo;
            this.rjObject['PromoVoucherItem']['DeviceID'] = this.deviceId;
            this.rjObject['PromoVoucherItem']['UserID'] = this.transactionDocument.userName;
            this.rjObject['PromoVoucherItem']['DateTimeCreated'] = this.createdAt;
            this.rjObject['PromoVoucherItem']['ProductId'] = ""; //todo
            this.rjObject['PromoVoucherItem']['SerialNumber'] = "" ; //todo
            this.rjObject['PromoVoucherItem']['MMGroupId'] = "";
        }
    }
    
    getQuantity(element: any) {
        let quantity
        if(this.transactionDocument.unreferencedRefund){
            quantity = element['quantity'] < 0 ? element['quantity'] : (-element['quantity']);
        }
        else{
            quantity = element['refundedQuantity'] < 0 ? element['refundedQuantity'] : (-element['refundedQuantity']);
        }
        return quantity;
    }
}
